import { configureStore } from '@reduxjs/toolkit';
import { tournamentsApi } from '@entities/tournaments';
import { teamsApi } from '@entities/teams';
import { accountsApi } from '@/entities/account';
import { bracketsApi } from '@/entities/brackets';
import { rewardsApi } from '@/entities/rewards/slice';
import { pushSlice } from '@/features/common/push/model/slice';
import { confirmationSlice } from '@/features/common/confirmation/model/slice';

export const store = configureStore({
  reducer: {
    [tournamentsApi.reducerPath]: tournamentsApi.reducer,
    [teamsApi.reducerPath]: teamsApi.reducer,
    [pushSlice.reducerPath]: pushSlice.reducer,
    [confirmationSlice.reducerPath]: confirmationSlice.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [bracketsApi.reducerPath]: bracketsApi.reducer,
    [rewardsApi.reducerPath]: rewardsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(
    tournamentsApi.middleware,
    teamsApi.middleware,
    accountsApi.middleware,
    bracketsApi.middleware,
    rewardsApi.middleware,
  ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
